import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
var store = new Vuex.Store({
  state: {
    user: null,
    // 是否登录标志，保存用户信息
    authHash: {},
    // 用于菜单、操作鉴权
    menuHash: {} // 用于导航守卫鉴权、重定向，获取导航菜单、获取激活的菜单、展开的子菜单等
  },
  mutations: {
    updateLoginInfo: function updateLoginInfo(state, data) {
      var user = data.user,
        authHash = data.authHash,
        menuHash = data.menuHash;
      if (typeof user !== 'undefined') state.user = user;
      if (typeof authHash !== 'undefined') state.authHash = authHash;
      if (typeof menuHash !== 'undefined') state.menuHash = menuHash;
    }
  }
});
export default store;